export default "__VITE_ASSET___Espx2EkBpJC0VwEAZifMA__"